<template>
  <v-dialog
    v-model="dialog"
    :width="$vuetify.breakpoint.mdAndUp ? '99%' : '100%'"
    :height="$vuetify.breakpoint.mdAndUp ? '99%' : '100%'"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="activator"
        v-bind="{ on, attrs }"
      ></slot>
    </template>
    <v-card
      class="d-flex flex-column align-stretch"
      :style="{
        height: $vuetify.breakpoint.height - 10 + 'px',
        position: 'relative'
      }"
    >
      <image-editor
        :include-ui="true"
        :options="options"
        ref="tuiImageEditor"
      ></image-editor>
      <div
        class="py-5 d-flex justify-center"
        :style="{ 'background-color': '#151515' }"
      >
        <avs-saveButton @click="save" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { ImageEditor } from "@toast-ui/vue-image-editor/src"
export default {
  name: "PictureEditor",
  components: { "image-editor": ImageEditor },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      options: {
        cssMaxWidth: 2000,
        cssMaxHeight: 2000,
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70
        },

        includeUI: {
          menuBarPosition: "bottom",
          menu: ["crop", "flip", "rotate", "draw", "shape", "icon", "text", "mask"],
          initMenu: "draw",
          usageStatistics: false,
          theme: {
            "header.display": "none"
          }
        }
      }
    }
  },
  mounted() {
    if (this.value) {
      this.updatePicture()
    }
  },
  methods: {
    cancel() {
      this.$refs.tuiImageEditor.invoke("clearObjects")
      this.dialog = false
    },
    save() {
      let base64str = this.$refs.tuiImageEditor.invoke("toDataURL")
      this.$emit("input", base64str)
      this.dialog = false
      this.$emit("custom-event", base64str)
    },
    updatePicture() {
      let $ = this
      this.options.includeUI.loadImage = {
        path: $.value,
        name: "My sample image"
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~tui-image-editor/dist/tui-image-editor.css";
@import "~tui-color-picker/dist/tui-color-picker.css";
.d-absolute {
  z-index: 999;
  position: absolute;
  bottom: 15px;
  right: 25px;
}
</style>
